import { getNewMovies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';
import { Link } from 'react-router-dom';

export default function LatestUpdates() {
  const newMovies = getNewMovies(8);

  const updates = [
    { title: '流浪地球3', info: 'HD高清版 今日上线', time: '2小时前', category: '科幻' },
    { title: '飞驰人生2', info: '院线版 高清上线', time: '5小时前', category: '喜剧' },
    { title: '乘风破浪的姐姐 第五季', info: '最新一期 已更新', time: '8小时前', category: '真人秀' },
    { title: '斗破苍穹', info: '更新至104集', time: '12小时前', category: '国产动漫' },
    { title: '一人之下 第五季', info: '最新话 已更新', time: '1天前', category: '国产动漫' },
    { title: '功夫熊猫4', info: '国语配音版上线', time: '1天前', category: '欧美动漫' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-2/3">
            <div className="flex items-end justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold mb-2">
                  最新上线
                </h2>
                <p className="text-sm text-foreground-500">新鲜出炉的热门影片</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
              {newMovies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="flex items-end justify-between mb-8">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold mb-2">
                  更新日志
                </h2>
                <p className="text-sm text-foreground-500">影视资源实时动态</p>
              </div>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-4">
              {updates.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-start gap-3 py-3 ${
                    index < updates.length - 1 ? 'border-b border-background-100' : ''
                  }`}
                >
                  <div className="w-2 h-2 mt-2 rounded-full bg-primary-400 flex-shrink-0"></div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-950">{item.title}</p>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.info}</p>
                  </div>
                  <div className="flex flex-col items-end gap-1 flex-shrink-0">
                    <span className="text-[11px] text-foreground-400">{item.time}</span>
                    <span className="text-[11px] px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md">
                      {item.category}
                    </span>
                  </div>
                </div>
              ))}
              <Link
                to="/category/movie"
                className="flex items-center justify-center gap-1.5 mt-3 pt-3 border-t border-background-100 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
              >
                查看全部更新
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}